module.exports = __webpack_public_path__ + "static/media/alerts.edcc56b9.md";